(function() {
    function setEqualHeight() {
        const headings = document.querySelectorAll('.case-studies__heading');
        const screenWidth = window.innerWidth;

        // Sprawdzenie szerokości ekranu.
        if (screenWidth >= 992) {
            // Jeśli ekran jest równy lub większy niż 992px, usuń wysokość ze wszystkich elementów.
            headings.forEach(heading => heading.style.height = '');
        } else {
            let maxHeight = 0;

            // Reset wysokości, aby uzyskać poprawne wartości podczas resize.
            headings.forEach(heading => heading.style.height = 'auto');

            // Znalezienie maksymalnej wysokości.
            headings.forEach(heading => {
                const headingHeight = heading.offsetHeight;
                if (headingHeight > maxHeight) {
                    maxHeight = headingHeight;
                }
            });

            // Zastosowanie maksymalnej wysokości do wszystkich elementów.
            headings.forEach(heading => heading.style.height = `${maxHeight}px`);
        }
    }

    // Uruchomienie funkcji na eventach `load` oraz `resize`.
    window.addEventListener('load', setEqualHeight);
    window.addEventListener('resize', setEqualHeight);
})();